import { Member } from './Member';
import { SubteamMember } from './SubteamMember';
import { Team } from './Team';
import { User } from './User';

export enum TeammatePermissionType {
    GUEST = 'Guest', // Read-Only
    MEMBER = 'Member', // Partial Update (Comment, etc.)
    ADMIN = 'Admin', // Create, Delete, Read, Fully Update
    OWNER = 'Owner', // Full-access
}

export enum TeammateStatusType {
    PENDING = 'Pending',
    ACTIVE = 'Active',
    DEACTIVATED = 'Deactivated',
    BLOCKED = 'Blocked',
}

export interface Teammate {
    id: string;
    user: User;
    team: Team;
    member: Member;
    subteamMemberships?: SubteamMember[];
    permission: TeammatePermissionType | undefined;
    status: TeammateStatusType | undefined;
    createdAt: Date;
    updatedAt: Date;
}
